import { createContext, ReactNode, useContext } from 'react';

export type DocumentDisplayConfig = {
  showPriceFields: boolean;
};

const DEFAULT_CONFIG: DocumentDisplayConfig = { showPriceFields: true };

const DocumentDisplayConfigContext = createContext<DocumentDisplayConfig>(DEFAULT_CONFIG);

export const DocumentDisplayConfigProvider = ({
  config,
  children,
}: {
  config: DocumentDisplayConfig;
  children: ReactNode;
}) => <DocumentDisplayConfigContext.Provider value={config}>{children}</DocumentDisplayConfigContext.Provider>;

export const useDocumentDisplayConfig = () => useContext(DocumentDisplayConfigContext);
